export const NOT_FOUND_ERROR_PAGE_ROUTE = "/page-introuvable";
export const SERVER_ERROR_PAGE_ROUTE = "/erreur-serveur";
export const NETWORK_ERROR_PAGE_ROUTE = "/erreur-reseau";
export const EXEMPLE_PAGE_ROUTE = "/";
export const EXEMPLE_PAGE_SECURE_ROUTE = "/secure";
export const EXEMPLE2_PAGE_ROUTE = "/exemple";
//
export const NEW_SUBSCRIPTIONS_PAGE_ROUTE = "/nouvelles-souscriptions";


// GESTION LICENCE

export const GESTION_LICENCE = "/gestion-licence";
export const CREATE_LICENCE = "/gestion-licence/create";
export const DETAIL_LICENCE = "/gestion-licence/:id/detail";
export const EDIT_LICENCE = "/gestion-licence/:id/edit";
export const AJOUT_COMPLEMENT = "/addComplementLicence";
export const AJOUT_ANALYSE_SUPP = "/addAnalyseSuppLicence";

///////////////////////////

export const GESTION_SUPER_VISOR_PAGE_ROUTE = "/gestion-super-visor";
export const NEW_SUPER_VISOR_PAGE_ROUTE = "/super-visor";
export const SUPER_VISOR_CONSULTER_PAGE_ROUTE = "/super-visor/consulter/:id";


export const GESTION_AGENT_PAGE_ROUTE = "/gestion-agent";
export const NEW_AGENT_PAGE_ROUTE = "/agent";
export const AGENT_CONSULTER_PAGE_ROUTE = "/agent/consulter/:id";

// Suppression des routes de paiement
// export const PAYMENT_PAGE_ROUTE = "/paiements";
// export const PAYMENT_SUCCESS_PAGE_ROUTE = "/paiements/success";

// Route pour mes paiements
export const MY_PAYMENTS_PAGE_ROUTE = "/mes-paiements";